import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './pages/login/login.component';
import { HomeComponent } from './pages/home/home.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatSidenavModule } from '@angular/material/sidenav';
import { HTTP_INTERCEPTORS, HttpClientModule, provideHttpClient } from '@angular/common/http';
import { MatIconModule } from '@angular/material/icon';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatNativeDateModule } from '@angular/material/core';
import {MatSelectModule} from '@angular/material/select';
import {MatTableModule} from '@angular/material/table';
import {MAT_DATE_LOCALE} from '@angular/material/core';
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { SettingsComponent } from './components/settings/settings.component';
import {MatButtonModule} from '@angular/material/button';
import { OrdPagoComponent } from './components/ord-pago/ord-pago.component';
import { FacturasComponent } from './components/facturas/facturas.component';
import {MatTooltipModule} from '@angular/material/tooltip';
import { MailingComponent } from './components/mailing/mailing.component';
import {MatMomentDateModule} from '@angular/material-moment-adapter';
import { AuthInterceptor } from './core/interceptors/auth.interceptor';
import { CurrencyPipe, DatePipe, registerLocaleData } from '@angular/common';
import { StepperComponent } from './shared/stepper/stepper.component';
import { CargaFacturasComponent } from './components/facturas-proveedor/carga-facturas/carga-facturas.component'; 
import { NuevaFacturaComponent } from './components/facturas-proveedor/nueva-factura/nueva-factura.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDialogModule } from '@angular/material/dialog';
  
import localeEsAr from '@angular/common/locales/es-AR';
import { MiniLoaderComponent } from "./shared/mini-loader/mini-loader.component";   
import { DatosFacturasProveedorComponent } from './components/facturas-proveedor/nueva-factura/componentes/datos-facturas-proveedor/datos-facturas-proveedor.component';
import { ListadosConceptosProveedorComponent } from './components/facturas-proveedor/nueva-factura/componentes/listados-conceptos-proveedor/listados-conceptos-proveedor.component';
import { TotalesFacturasProveedorComponent } from './components/facturas-proveedor/nueva-factura/componentes/totales-facturas-proveedor/totales-facturas-proveedor.component';
import { ModalCentrosCostoComponent } from './shared/modal-centros-costo/modal-centros-costo.component';
import { LoaderComponent } from './shared/loader/loader.component';
import { ModalSubirPdfComponent } from './components/modal-subir-pdf/modal-subir-pdf.component';
import { ToastComponent } from './shared/toast/toast.component';
import { AlertModalComponent } from './shared/alert-modal/alert-modal.component';
import { AutocompleteConFiltrosComponent } from './shared/autocomplete-con-filtros/autocomplete-con-filtros.component';
import { FacturasProveedoresComponent } from './components/facturas-proveedores/facturas-proveedores.component';
// Register the locale data for 'es-AR'
registerLocaleData(localeEsAr, 'es-AR'); 

@NgModule({ 
     declarations: [
        AppComponent,
        LoginComponent,
        HomeComponent,
        SettingsComponent,
        OrdPagoComponent,
        FacturasComponent,
        MailingComponent,
        StepperComponent,
        CargaFacturasComponent,
        NuevaFacturaComponent, 
        MiniLoaderComponent,
        DatosFacturasProveedorComponent,
        ListadosConceptosProveedorComponent,
        TotalesFacturasProveedorComponent,
        ModalCentrosCostoComponent,
        LoaderComponent,
        ModalSubirPdfComponent,
        AlertModalComponent,
        FacturasProveedoresComponent
        
    ],
    imports: [BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatSidenavModule,
    FormsModule,
    HttpClientModule,
    MatIconModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    MatNativeDateModule,
    MatSelectModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    SweetAlert2Module,
    ReactiveFormsModule,
    MatButtonModule,
    MatTooltipModule,
    MatMomentDateModule,
    MatSnackBarModule,
    MatDialogModule,
    ToastComponent,
    AutocompleteConFiltrosComponent], 
      providers: [
        { provide: MAT_DATE_LOCALE, useValue: 'es-ES' },
        { provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true,
        },
        DatePipe,
        CurrencyPipe, 
        { provide: LOCALE_ID, useValue: 'es-AR' }
    ],
        
    bootstrap: [AppComponent] })
export class AppModule { }
